'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /**
                    * @copyright 2015-present, Prometheus Research, LLC
                    */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStylesheet = require('react-stylesheet');

var Stylesheet = _interopRequireWildcard(_reactStylesheet);

var _Component2 = require('./Component');

var _Component3 = _interopRequireDefault(_Component2);

var _Error = require('./Error');

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ErrorList = (_temp = _class = function (_Component) {
  _inherits(ErrorList, _Component);

  function ErrorList() {
    _classCallCheck(this, ErrorList);

    return _possibleConstructorReturn(this, (ErrorList.__proto__ || Object.getPrototypeOf(ErrorList)).apply(this, arguments));
  }

  _createClass(ErrorList, [{
    key: 'render',
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          noLabel = _props.noLabel,
          hideNonForced = _props.hideNonForced,
          complete = _props.complete,
          schemaType = _props.schemaType,
          stylesheet = _props.stylesheet,
          formValue = _props.formValue,
          select = _props.select,
          label = _props.label,
          props = _objectWithoutProperties(_props, ['noLabel', 'hideNonForced', 'complete', 'schemaType', 'stylesheet', 'formValue', 'select', 'label']);

      var _ref = stylesheet || this.constructor.stylesheet,
          Root = _ref.Root,
          Error = _ref.Error;

      var errorList = complete ? this.formValue.completeErrorList : this.formValue.errorList;
      if (schemaType !== undefined) {
        errorList = errorList.filter(function (error) {
          return error.schema ? schemaType[error.schema.type] : schemaType.none;
        });
      }
      if (hideNonForced) {
        errorList = errorList.filter(function (error) {
          return error.force;
        });
      }
      if (errorList.length === 0) {
        return null;
      }
      var items = errorList.map(function (error, index) {
        return _react2.default.createElement(Error, {
          key: error.field + '__' + index,
          error: error,
          noLabel: noLabel,
          complete: complete
        });
      });
      return _react2.default.createElement(
        Root,
        props,
        items
      );
    }
  }]);

  return ErrorList;
}(_Component3.default), _class.propTypes = _extends({}, _Component3.default.propTypes, {

  /**
   * If component should render errors from all the subvalues.
   */
  complete: _propTypes2.default.bool,

  /**
   * Show errors.
   */
  hideNonForced: _propTypes2.default.bool,

  /**
   * Restrict schema types
   */
  schemaType: _propTypes2.default.object,

  noLabel: _propTypes2.default.bool,

  label: _propTypes2.default.string
}), _class.stylesheet = Stylesheet.create({
  Error: _Error2.default,
  Root: 'div'
}), _temp);
exports.default = ErrorList;
